export default "__VITE_ASSET__BsND7W2a__"